import { Box, getToken, useTheme } from '@chakra-ui/react';
import { useSidebarContext } from 'context/SidebarContext';
import { useMemo } from 'react';
import Snowfall from 'react-snowfall';

import { activeSeasonalEffectConfig } from './seasonalEffectConfig';

const createColoredSvgImage = (svg: string, color: string) => {
  const image = document.createElement('img');
  image.src = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg.replace('<svg ', `<svg fill="${color}" `))}`;
  return image;
};

export const SeasonalEffect = () => {
  const theme = useTheme();
  const { isSeasonalEffectEnabled } = useSidebarContext();

  const images = useMemo(() => {
    if (!activeSeasonalEffectConfig) {
      return [];
    }

    return activeSeasonalEffectConfig.shapes.flatMap(({ svg, colorTokens }) => {
      const colors: string[] = getToken('colors', colorTokens)(theme);
      return colors.map((color) => createColoredSvgImage(svg, color));
    });
  }, [theme]);

  if (!activeSeasonalEffectConfig || !isSeasonalEffectEnabled) {
    return null;
  }

  // zIndex -1 places the effect between the parent's background and its content.
  // Requires the parent to be positioned and form a stacking context (e.g. isolation="isolate").
  return (
    <Box pointerEvents="none" position="absolute" inset="0" zIndex={-1}>
      <Snowfall {...activeSeasonalEffectConfig.snowfall} images={images} />
    </Box>
  );
};
